module.exports = __webpack_public_path__ + "img/varhage355.38e7915b.jpg";